<template>
  <v-container fluid class="pa-2">
<!--    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>-->

    <!-- CONNECTION WATCH-ON-THE-GO SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-12 col-lg-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0 text-break"><strong>{{ $t('cards.texts.vimeoTitle') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.vimeoDescription') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-12 col-lg-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="connectionLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!connectionLoading">
            <!-- IPHONE -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2">
                <div><strong>{{ $t('cards.texts.loginDetails') }}</strong></div>
                <div>{{ $t('cards.texts.loginDetailsDescription') }}</div>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-6 pa-2" v-html="$t('cards.texts.vimeoLogin', { email: connection.email })">
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigateExternal('https://watch.movetohappiness.com/forgot_password')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
              <!--<div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>-->
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <!-- DEVICES SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-12 col-lg-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0 text-break"><strong>{{ $t('cards.titles.devices') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.devices') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-12 col-lg-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="connectionLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!connectionLoading">
            <!-- IPHONE -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2">
                <div><strong>Iphone</strong></div>
                <!--<div>{{ $t('cards.texts.vimeoDescription') }}</div>-->
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-6 pa-2" v-html="$t('cards.texts.vimeoIphone')">
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigateExternal('https://itunes.apple.com/us/app/id1629931818')"
                  >
                    App Store
                  </v-btn>
                </div>
              </div>
              <div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>
            </div>

            <!-- IPAD -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2">
                <div><strong>Ipad</strong></div>
                <!--<div>{{ $t('cards.texts.vimeoDescription') }}</div>-->
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-6 pa-2" v-html="$t('cards.texts.vimeoIpad')">
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigateExternal('https://itunes.apple.com/us/app/id1629931818')"
                  >
                    App Store
                  </v-btn>
                </div>
              </div>
              <div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>
            </div>

            <!-- ANDROID -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2">
                <div><strong>Android</strong></div>
                <!--<div>{{ $t('cards.texts.vimeoDescription') }}</div>-->
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-6 pa-2" v-html="$t('cards.texts.vimeoAndroid')">
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigateExternal('https://play.google.com/store/apps/details?id=ott.movetohappiness')"
                  >
                    Play Store
                  </v-btn>
                </div>
              </div>
              <!--<div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>-->
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            icon
            @click="snack = false"
        >
          <v-icon>fal fa-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
  </v-container>

</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-watch-on-the-go",
  props: [],
  components: {
  },
  data() {
    return {
      isLoading: false,
      connection: {
        email: "",
        firstName: "",
        lastName: "",
        vimeoConnected: ""
      },
      snack: false,
      snackColor: '',
      snackText: '',
      connectionLoading: false
    }
  },
  mounted() {
    this.fetchConnection()
  },
  
  methods: {
    async fetchConnection() {
      const that = this
      that.connectionLoading = true
      await api.connections.getWatchOnTheGo()
          .then((res) => {
            that.connection = res.data
            that.connectionLoading = false
          })
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
    
    navigateExternal(route){
      this.$root.$emit('m2h-loader-show')
      window.open(route, '_blank')
    }
  }
}
</script>

<style scoped>

</style>